import { useLocation } from "react-router-dom";

const ALLOWED_RETURN_PATHS = new Set(["/today", "/tasks", "/stats", "/settings", "/esp"]);

export function LoginPage() {
  const location = useLocation();
  const returnPath = ALLOWED_RETURN_PATHS.has(location.pathname)
    ? location.pathname
    : "/today";
  const loginUrl = `/api/v2/auth/google/start?returnTo=${encodeURIComponent(`/app${returnPath}`)}`;
  const authFailed = new URLSearchParams(location.search).has("error");

  return (
    <main className="login-page">
      <section className="login-card" aria-labelledby="login-title">
        <div className="brand-mark" aria-hidden="true">
          <span />
          <span />
          <span />
          <span />
        </div>
        <p className="eyebrow">我們家</p>
        <h1 id="login-title">今天，一起完成。</h1>
        <p className="login-intro">
          把一家人的待辦放在同一個地方，手機新增、家中面板一起勾選。
        </p>
        {authFailed ? (
          <p className="notice notice-error" role="alert">
            登入沒有完成。請確認使用已授權的家庭帳號，再試一次。
          </p>
        ) : null}
        <a className="button button-primary button-wide" href={loginUrl}>
          <GoogleGlyph />
          使用 Google 登入
        </a>
        <p className="login-footnote">只開放給已授權的家庭帳號</p>
      </section>
    </main>
  );
}

function GoogleGlyph() {
  return (
    <svg aria-hidden="true" viewBox="0 0 24 24" width="20" height="20">
      <path
        fill="currentColor"
        d="M21.6 12.2c0-.7-.1-1.5-.2-2.2H12v4.2h5.4a4.6 4.6 0 0 1-2 3v2.7h3.4c2-1.8 2.8-4.5 2.8-7.7Z"
      />
      <path
        fill="currentColor"
        opacity=".75"
        d="M12 22c2.7 0 5-.9 6.8-2.4l-3.4-2.7c-.9.6-2.1 1-3.4 1a6 6 0 0 1-5.6-4.1H2.9v2.8A10.3 10.3 0 0 0 12 22Z"
      />
      <path
        fill="currentColor"
        opacity=".55"
        d="M6.4 13.8a6 6 0 0 1 0-3.6V7.4H2.9a10.3 10.3 0 0 0 0 9.2l3.5-2.8Z"
      />
      <path
        fill="currentColor"
        opacity=".9"
        d="M12 6.1c1.5 0 2.9.5 3.9 1.5l3-3A10 10 0 0 0 2.9 7.4l3.5 2.8A6 6 0 0 1 12 6Z"
      />
    </svg>
  );
}
